<template>
  <div id="app">
    <audio ref="flipSound" :src="flipSoundUrl" preload="auto"></audio>

    <div v-if="isLoading" class="loading-screen">
      <div class="spinner"></div>
      <p>Loading Menu Pages...</p>
      <p class="progress">{{ loadedCount }} / {{ totalCount }}</p>
    </div>

    <template v-else>
      <div class="flipbook-container">
        <flipbook
          ref="flipbook"
          class="flipbook-style"
          :pages="pages"
          :flipDuration="1500"
          :zoomDuration="750"
          :zooms="[1]"
          :singlePage="isMobile"
          :dragToFlip="true"
          :clickToZoom="false"
          @flip-left-start="onFlipLeft"
          @flip-right-start="onFlipRight"
        />
      </div>

      <!-- HEADER -->
      <header class="header">
        <img src="https://www.drinknhouse.in/drinknhouse.png" alt="DrinkNHouse Logo" class="logo" />
        <h1>DrinkNHouse</h1>
      </header>

      <!-- FOOTER -->
      <footer class="footer">
        <a href="https://www.drinknhouse.in" class="back-button">Back to Website</a>
        <div class="back-button disabled-button">Coming Soon</div>
        <div class="back-button disabled-button">Coming Soon</div> 
      </footer>
    </template>
  </div>
</template>

<script>
import Flipbook from "flipbook-vue/vue2";

export default {
  components: { Flipbook },
  data() {
    return {
      isLoading: true,
      loadedCount: 0,
      isMobile: false,
      imageUrls: ["/2.jpeg", "/4.jpeg", "/3.jpeg", "/1.jpeg", "/5.jpeg", "/6.jpeg", "/7.jpeg", "/8.jpeg","/9.jpeg"],
      totalCount: 6,
      flipSoundUrl: "data:audio/mp3;base64,//uQxAAA...",
      pages: [null, "/2.jpeg", "/4.jpeg", "/3.jpeg", "/1.jpeg", "/5.jpeg", "/6.jpeg", "/7.jpeg", "/8.jpeg","/9.jpeg"],
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    this.preloadAllAssets();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    preloadAllAssets() {
      const promises = this.imageUrls.map(
        (url) =>
          new Promise((resolve) => {
            const img = new Image();
            img.onload = img.onerror = () => {
              this.loadedCount++;
              resolve();
            };
            img.src = url;
          })
      );
      Promise.all(promises).then(() => {
        this.isLoading = false;
      });
    },
    onFlipLeft(e) {
      if (e.page <= 0) e.preventDefault();
    },
    onFlipRight(e) {
      if (e.page >= this.pages.length - 2) e.preventDefault();
    },
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background: #202222;
  min-height: 100vh;
  width: 100vw;
  overflow: hidden;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: flex-start;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #f7f7f7;
  padding: 10px 0;
}

/* LOADING */
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #202222;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  z-index: 1000;
}
.spinner {
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top: 5px solid #ff0055;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* HEADER */
.header {
  display: flex;
  align-items: center;
  margin: 5px 0 15px 0;
}
.logo {
  height: 45px;
  margin-right: 15px;
  border-radius: 60px;
}
.header h1 {
  font-size: 2rem;
  margin: 0;
}

/* FOOTER */
.footer {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.back-button {
  display: inline-flex;
  justify-content: start;
  align-items: start;
  padding: 8px 20px;
  background: #1a1a1a;
  color: #fff;
  border-radius: 25px;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 10px;
  text-decoration: none;
}
.disabled-button {
  background: #202222;
  color: #202222;
  pointer-events: none;
  opacity: 0.7;
}

/* FLIPBOOK */
.flipbook-container {
  width: 100%;
  flex-grow: 1;
  height: calc(100vh - 160px);
}
.flipbook-style {
  width: 95vw;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  border-radius: 8px;
}

/* MOBILE */
@media (max-width: 768px) {
  .header h1 { font-size: 0.5rem; }
  .logo { height: 30px; }
  .back-button,
  .disabled-button { padding: 7px 16px; font-size: 0.8rem; }
  .flipbook-container { height: calc(100vh - 140px); }
}
@media (max-width: 480px) {
  .header h1 { font-size: 1.2rem; }
  .logo { height: 30px; }
  .back-button,
  .disabled-button { padding: 6px 14px; font-size: 0.75rem; }
  .flipbook-container { height: calc(100vh - 120px); }
}
</style>